export default __webpack_public_path__ + "locales/fr/DeleteSelfProfileDialog.json?hash=707a2efab6dff6999cfb5f43422b74ba";